import cn from 'classnames';
import { Form } from 'formik';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { FormLabel, Input } from '@infologistics/frontend-libraries';

import { getErrorText, hasError } from '@utils/utils';

import { ISSOAuthFormProps as IProps } from '../../types';

import styles from '../../../../../AuthNew.module.scss';
import { ICON_PROPS } from '../../../consts';
import { LoginButtons } from '../../../LoginButtons';
import { AuthTranslations } from '@app/const/translations';

const SSOAuthForm: FC<IProps> = (props) => {
  const { errors, handleChange, onEmailLoginClick, onPhoneLoginClick, touched, values, handleBlur, isValid } = props;

  const { oguid } = values;

  const { t } = useTranslation();

  return (
    <Form>
      <div className='mb-6'>
        <FormLabel htmlFor='oguid' text={t('auth:federationID')} className={cn(styles.label, 'text-muted')} />
        <Input
          errorText={t(getErrorText('oguid', errors))}
          hasError={hasError('oguid', errors, touched)}
          value={oguid}
          id='oguid'
          name='oguid'
          onChange={(e) => {
            handleChange(e);
            handleBlur(e);
          }}
          inputSize='md'
          classes={{ wrapper: cn(styles.input), input: cn(styles.inputs, styles.input_radius) }}
          rightIcon='IconAdministrator'
          rightIconProps={{ ...ICON_PROPS, classes: styles.input_icon }}
        />
      </div>
      <LoginButtons
        isDisabled={!isValid}
        main={{
          text: AuthTranslations.continue,
        }}
        left={{
          onClick: onPhoneLoginClick,
          text: AuthTranslations.loginByPhone,
        }}
        right={{
          onClick: onEmailLoginClick,
          text: AuthTranslations.loginByEmail,
        }}
      />
    </Form>
  );
};

export default SSOAuthForm;
